/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { Component, Fragment } from 'react';

import { withStyles, createMuiTheme, ThemeProvider } from '@material-ui/core/styles'
import { Tooltip, IconButton, Paper, Popper, Typography, Divider, ExpansionPanel, ExpansionPanelSummary, ExpansionPanelDetails, ExpansionPanelActions, Button, ClickAwayListener, Avatar } from '@material-ui/core'
import { ExitToAppOutlined, AutorenewTwoTone, Clear, ExpandMore, BubbleChart, Label } from '@material-ui/icons'

import Actions from '../../../fluid/Actions/ActionFactory'

const blue_theme = createMuiTheme({
    palette: {
      primary: {
        main: "#2296f3",
      },
      secondary: {
        main: "#dc004e",
      },
    },
});

const styles = theme => ({

})

let op_steps = [
    {
        name : "Recommend",
        advance_pipeline : true,
        default_action : "train",
        default_act_label : "Initiate Training",
        steps : [
            {
                name : "Data Transfer",
                action : "data_transfer",
                act_label : "Transfer Data",
                act_enabled : false,
                icon : ExitToAppOutlined,
                color : "#2296f3"
            },
            {
                name : "Train",
                action : "train",
                act_label : "Initiate Training",
                act_enabled : true,
                icon : AutorenewTwoTone,
                color : "#2296f3"
            }
        ]
    },
    {
        name : "Classify",
        advance_pipeline : true,
        default_action : "train",
        default_act_label : "Initiate Training",
        steps : [
            {
                name : "Data Transfer",
                action : "data_transfer",
                act_label : "Transfer Data",
                act_enabled : false,
                icon : ExitToAppOutlined,
                color : "#2296f3"
            },
            {
                name : "Train",
                action : "train",
                act_label : "Initiate Training",
                act_enabled : true,
                icon : AutorenewTwoTone,
                color : "#2296f3"
            }
        ]
    },
    {
        name : "TopicModel",
        advance_pipeline : true,
        default_action : "train",
        default_act_label : "Initiate Training",
        steps : [
            {
                name : "Data Transfer",
                action : "data_transfer",
                act_label : "Transfer Data",
                act_enabled : false,
                icon : ExitToAppOutlined,
                color : "#2296f3"
            },
            {
                name : "Train",
                action : "train",
                act_label : "Initiate Training",
                act_enabled : true,
                icon : AutorenewTwoTone,
                color : "#2296f3"
            }
        ]
    },
    {
        name : "ImageToText",
        advance_pipeline : false,
        steps : []
    },
    {
        name : "LangDetect",
        advance_pipeline : false,
        steps : []
    },
    {
        name : "NER",
        advance_pipeline : false,
        steps : []
    },
    {
        name : "Deduplicate",
        advance_pipeline : true,
        default_action : "initiate_model",
        default_act_label : "Initiate Model",
        steps : [
            {
                name : "Data Transfer",
                action : "data_transfer",
                act_label : "Transfer Data",
                act_enabled : false,
                icon : ExitToAppOutlined,
                color : "#2296f3"
            },
            {
                name : "Model Initiation",
                action : "initiate_model",
                act_label : "Initiate Model",
                act_enabled : true,
                icon : BubbleChart,
                color : "#2296f3"
            },
            {
                name : "Label Samples",
                action : "label_samples",
                act_label : "Label Samples",
                act_enabled : false,
                icon : Label,
                color : "#2296f3"
            },
            {
                name : "Train",
                action : "train",
                act_label : "Initiate Training",
                act_enabled : false,
                icon : AutorenewTwoTone,
                color : "#2296f3"
            }
        ]
    }
]

class TrainTrigger extends Component {
    state = {
        enabled : true,
        open : false,
        anchorEl : null,
    }

    componentDidMount() {
        
    }

    getEnabledState = (ic_data) => {

    }

    togglePopover = (event) => {
        console.log("AnchorEl: ", event.currentTarget)
        if (this.state.open) {
            this.setState({...this.state, anchorEl : null, open : false})
        } else {
            this.setState({...this.state, anchorEl : event.currentTarget, open : true})
        }
    }

    handleClose = () => {
        this.setState({...this.state, anchorEl : null, open : false})
    }

    clickAway = () => {
        if (this.state.open) {
            this.setState({...this.state, anchorEl : null, open : false})
        }
    }

    renderOperations = () => {
        let operations = this.props.ic_data.operations.map(op => {
            return this.renderOperation(op)
        })

        return operations
    }

    renderOperation = (operation) => {
        let op_name = this.props.ic_data.operationAnnotations.find(op => op.type === operation).annotation
        let act_label = op_steps.find(op => op.name === operation).default_act_label
        let default_action = op_steps.find(op => op.name === operation).default_action
        return (
            <ExpansionPanel>
                <ExpansionPanelSummary
                    style = {{borderBottom : '1px solid rgba(0,0,0,0.12)'}}
                    expandIcon={<ExpandMore />}
                >
                    <div style = {{flexGrow : 1}}>
                        <Typography variant = 'subtitle2' color = 'primary'>{op_name}</Typography>
                        <div style = {{marginTop : '5px', display : 'flex', flexDirection : 'row'}}>
                            {this.renderOperationSteps(operation)}
                        </div>
                    </div>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails>
                    <Typography variant = 'subtitle2'>Pipeline</Typography>
                </ExpansionPanelDetails>
                <ExpansionPanelActions>
                    <Button variant = 'contained' color = 'primary' size = 'small' onClick = {() => this.advancePipeline(operation, default_action)}>
                        {act_label}
                    </Button>
                </ExpansionPanelActions>
            </ExpansionPanel>
        )
    }

    renderOperationSteps = (operation) => {
        let operation_steps = op_steps.find(op => op.name === operation).steps
        return (
            <div style = {{display : 'flex', flexDirection : 'row', alignItems : 'center'}}>
                {this.renderSteps(operation_steps)}
            </div>
        )
    }

    renderSteps = (operation_steps) => {
        let steps = operation_steps.map((step, i) => {
            return this.renderStep(operation_steps, i)
        })

        return steps
    }

    renderStep = (operation_steps, step_index) => {
        return (
            <div style = {{display : 'flex', flexDirection : 'row', alignItems : 'center'}}>
                <Tooltip title = {operation_steps[step_index].name}>
                    {this.renderIcon(operation_steps[step_index].icon, {fontSize : 'small'})}
                </Tooltip>
                {/* <Typography variant = 'caption'>{operation_steps[step_index].name}</Typography> */}
                {step_index < operation_steps.length - 1 ? <div style = {{marginLeft : '5px', marginRight : '5px', width : '50px', height : '2px', backgroundColor : 'rgba(0,0,0,0.12)'}}></div> : null}
            </div>
        )
    }

    renderIcon = (icon_name, props) => {
        return (
            <IconButton size = 'small'>
                {React.createElement(icon_name, props)}
            </IconButton>
        )
    }

    advancePipeline = (operation, action) => {
        if (action === "train") {
            let api_data = [
                {
                    ic_name : this.props.ic_data.name,
                    operations : [operation]
                }
            ]

            Actions('http_request', {
                url: "/sainapse/train",
                method: "post",
                data : api_data
            }).then(res => {
                this.setState({
                    ...this.state,
                    open : false,
                    anchorEl : null
                }, () => {
                    this.props.get_data()
                })
            })
        } else if (action === 'initiate_model') {
            let api_data = {
                ic_name : this.props.ic_data.name
            }

            Actions('http_request', {
                url : "/sainapse/model_initialization",
                method : 'post',
                data : api_data
            }).then(res => {
                this.setState({
                    ...this.state,
                    open : false,
                    anchorEl : null
                }, () => {
                    this.props.get_data()
                })
            })
        }
    }

    renderPopOver = () => {
        const { classes } = this.props
        return(
            <Popper
                key = {"training-trigger"}
                open={this.state.open}
                anchorEl={this.state.anchorEl}
                placement="bottom-end"
                modifiers={{
                    flip: {
                        enabled: true,
                    },
                    preventOverflow: {
                        enabled: false,
                        boundariesElement: 'scrollParent',
                    }
                }}
            >
                <ClickAwayListener onClickAway = {this.handleClose}>
                    <Paper elevation = {6} style = {{backgroundColor : "#FAFBFC", width : '600px'}}>
                        <div style = {{width : '600px', padding : '2%'}}>
                            <div style = {{width : '100%', display : 'flex', flexDirection : 'row', alignItems : 'center'}}>
                                <div>
                                    <Avatar style = {{backgroundColor : "#4caf50", marginRight : '10px'}}>
                                        <AutorenewTwoTone style = {{color : '#FFFFFF'}} fontSize = 'small'/>
                                    </Avatar>
                                </div>
                                <div style = {{flexGrow : 1}}>
                                    <Typography variant = 'subtitle2'>Training Operations</Typography>
                                    <Typography variant = 'caption' color = 'textSecondary'>{this.props.ic_data.name}</Typography>
                                </div>
                                <div>
                                    <IconButton style = {{marginLeft : '10px'}} size = 'small' color = 'secondary' onClick = {this.handleClose}>
                                        <Clear fontSize = 'small'/>
                                    </IconButton>
                                </div>
                            </div>
                        </div>
                        <Divider/>
                        {this.renderOperations()}
                        {/* <Divider style = {{marginTop : '5px'}}/>
                        <div style = {{width : '100%', padding : '10px', display : 'flex', flexDirection : 'row-reverse'}}>
                            <Button variant = 'contained' color = 'primary' size = 'small'>Advace Pipeline for all operations</Button>
                        </div> */}
                    </Paper>
                </ClickAwayListener>
            </Popper>
        )
    }

    render() { 
        const { classes } = this.props
        return (
            <Fragment>
                <ThemeProvider theme = {blue_theme}>
                    <Tooltip title="Re(Train)" arrow>
                        <IconButton
                            style = {{
                                color : this.state.enabled ? "#4caf50" : null,
                                display : this.state.enabled ? "block" : "none"
                            }}
                            size = 'small'
                            disabled = {!this.state.enabled}
                            onClick = {(event) => this.togglePopover(event)}
                        >
                            <AutorenewTwoTone fontSize="small"/>
                        </IconButton>
                    </Tooltip>
                    {this.renderPopOver()}
                </ThemeProvider>
            </Fragment>
        );
    }
}
 
export default withStyles(styles)(TrainTrigger);